export function formatBeijingDateTime(value) {
  if (!value) return '-'
  if (typeof value === 'string') {
    const normalized = value.replace('T', ' ').replace(/\.\d+$/, '')
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(normalized)
      && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
      return normalized.length === 16 ? `${normalized}:00` : normalized
    }
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return String(value).replace('T', ' ').replace(/\.\d+$/, '')
  }
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(date).reduce((result, item) => {
    result[item.type] = item.value
    return result
  }, {})
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}
